import * as React from "react";
import { Dropdown } from "@mui/base/Dropdown";
import { Menu } from "@mui/base/Menu";
import { MenuButton as BaseMenuButton } from "@mui/base/MenuButton";
import { MenuItem as BaseMenuItem, menuItemClasses } from "@mui/base/MenuItem";
import { styled } from "@mui/system";

/** The reason «مفتوح» is refused, in the words of api#147. */
const WALLET_REOPEN_MESSAGE = "يجب أن يكون رصيد المحفظة أكبر من صفر لفتح المطعم";

export default function MenuSimple(props) {
    // THE WALLET BLOCK (api#147). While the wallet keeps the restaurant closed,
    // the server refuses «مفتوح». The option stays visible but disabled, with
    // the reason, so the operator sees WHY instead of a click that does nothing.
    const openBlocked = props.walletBlocked === true;

    const updateStatus = async (status) => {
        const fm = new FormData();
        fm.append("id", props.id);
        fm.append("status", status);
        try {
            await props.updateVendor(fm);
        } catch (err) {
            // Used to be an unhandled rejection: the chip snapped back with no
            // word. The status shown is always the server's, refetched after
            // every attempt, so this only has to say why it did not change.
            props.showMessage?.(
                "error",
                "تعذر تغيير الحالة",
                err.response?.data?.message || "حدث خطأ غير متوقع",
            );
        }
    };

    return (
        <Dropdown>
            <MenuButton className={props.status}>
                {status.find((e) => e.en === props.status)?.ar}
            </MenuButton>
            <Menu slots={{ listbox: Listbox }}>
                {status
                    .filter((s) => s.en !== props.status)
                    .map((e) => {
                        const disabled = e.en === "open" && openBlocked;

                        return (
                            <MenuItem
                                disabled={disabled}
                                title={disabled ? WALLET_REOPEN_MESSAGE : undefined}
                                onClick={() => {
                                    if (!disabled) updateStatus(e.en);
                                }}
                                key={e.en}
                            >
                                {e.ar}
                                {disabled ? " — رصيد المحفظة غير كافٍ" : ""}
                            </MenuItem>
                        );
                    })}
            </Menu>
        </Dropdown>
    );
}

const status = [
    { en: "close", ar: "مغلق" },
    { en: "open", ar: "مفتوح" },
    { en: "soon", ar: "قريبا" },
    { en: "busy", ar: "مشغول" },
];
const grey = {
    50: "#F3F6F9",
    100: "#E5EAF2",
    200: "#DAE2ED",
    300: "#C7D0DD",
    400: "#B0B8C4",
    500: "#9DA8B7",
    600: "#6B7A90",
    700: "#434D5B",
    800: "#303740",
    900: "#1C2025",
};

const Listbox = styled("ul")(
    ({ theme }) => `
  font-family: 'cairo', sans-serif;
  font-size: 0.875rem;
  box-sizing: border-box;
  padding: 6px;
  margin: 12px 0;
  min-width: 120px;
  border-radius: 12px;
  overflow: auto;
  outline: 0;
  background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
  border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
  color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
  box-shadow: 0 4px 6px ${
      theme.palette.mode === "dark" ? "rgba(0,0,0, 0.50)" : "rgba(0,0,0, 0.05)"
  };
  z-index: 1;
  `,
);

const MenuItem = styled(BaseMenuItem)(
    ({ theme }) => `
  list-style: none;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;

  &:last-of-type {
    border-bottom: none;
  }

  &:focus {
    background-color: ${theme.palette.mode === "dark" ? grey[800] : grey[100]};
    color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
  }

  &.${menuItemClasses.disabled} {
    color: ${theme.palette.mode === "dark" ? grey[700] : grey[400]};
  }
  `,
);

const MenuButton = styled(BaseMenuButton)(
    ({ theme }) => `
  font-family: 'cairo', sans-serif;
  font-weight: 600;
  width:100px;
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 150ms ease;
  cursor: pointer;
  color:#fff;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);

  &:hover {
    opacity:0.7
  }

  &:active {
    background: ${theme.palette.mode === "dark" ? grey[700] : grey[100]};
  }
  `,
);
